import { render, staticRenderFns } from "./multidamageForm.pug?vue&type=template&id=6569874f&lang=pug&external"
import script from "./multidamageForm.js?vue&type=script&lang=js&external"
export * from "./multidamageForm.js?vue&type=script&lang=js&external"
import style0 from "./multidamageForm.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6569874f')) {
      api.createRecord('6569874f', component.options)
    } else {
      api.reload('6569874f', component.options)
    }
    module.hot.accept("./multidamageForm.pug?vue&type=template&id=6569874f&lang=pug&external", function () {
      api.rerender('6569874f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/multidamageForm/index.vue"
export default component.exports